import { eTitleSearchStatus } from '../order/title/eTitleSearchStatus';
import { ISearchOrdersSettingsData } from './ISearchOrdersSettingsData';
import { createDefaultAddressData, IAddressData } from '../../ui-toolkit/orders/interfaces/IAddressResponse';

export interface IVendorOrdersResponse {
  titleSearches: IVendorOrderResponse[];
  page: number;
  pageSize: number;
  total: number;
}

export interface IVendorOrdersData {
  titleSearches: IVendorOrderData[];
  total: number;
}

export const createDefaultVendorOrdersData = (): IVendorOrdersData => ({
  titleSearches: [],
  total: 1,
});

export const convertFromVendorOrdersResponseToVendorOrdersData = (data: IVendorOrdersResponse): IVendorOrdersData => ({
  titleSearches: data.titleSearches,
  total: data.total,
});
export const convertFromVendorOrdersDataAndSearchSettingsToVendorOrdersResponse = (
  data: IVendorOrdersData,
  searchSettings: ISearchOrdersSettingsData
): IVendorOrdersResponse => ({
  titleSearches: data.titleSearches,
  page: searchSettings.page,
  pageSize: searchSettings.pageSize,
  total: data.total,
});

export interface IVendorOrderResponse {
  orderId: string;
  titleSearchId: string;
  fileNumber: string;
  borrowers: string;
  address: IAddressData;
  timeEnteredQueue: string;
  status: eTitleSearchStatus;
}

export interface IVendorOrderData extends IVendorOrderResponse {
  address: IAddressData;
}

export const createDefaultVendorOrderData = (): IVendorOrderData => ({
  orderId: '',
  titleSearchId: '',
  fileNumber: '',
  borrowers: '',
  address: createDefaultAddressData(),
  timeEnteredQueue: '',
  status: eTitleSearchStatus.new,
});

export const convertFromVendorOrderResponseToVendorOrderData = (data: IVendorOrderResponse): IVendorOrderData => data;
export const convertFromVendorOrderDataToVendorOrderResponse = (data: IVendorOrderData): IVendorOrderResponse => data;
